module.exports = __webpack_public_path__ + "img/right-arm_hover.0927df39.png";